import { render } from "./recommendicon.vue?vue&type=template&id=2999ee40&scoped=true"
import script from "./recommendicon.vue?vue&type=script&lang=js"
export * from "./recommendicon.vue?vue&type=script&lang=js"

import "./recommendicon.vue?vue&type=style&index=0&id=2999ee40&scoped=true&lang=css"

import exportComponent from "D:\\startup\\gtdhtml5\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2999ee40"]])

export default __exports__